type VisualGeomOriginPickMode = "meshReference";

type VisualGeomOriginPickState = {
  active: boolean;
  mode: VisualGeomOriginPickMode;
  meshUuid: string | null;
  bodyUuid: string | null;
  geomUuid: string | null;
};

let state: VisualGeomOriginPickState = {
  active: false,
  mode: "meshReference",
  meshUuid: null,
  bodyUuid: null,
  geomUuid: null,
};

export function getVisualGeomOriginPickState(): VisualGeomOriginPickState {
  return state;
}

export function activateVisualGeomOriginPick({
  mode = "meshReference",
  meshUuid = null,
  bodyUuid,
  geomUuid,
}: {
  mode?: VisualGeomOriginPickMode;
  meshUuid?: unknown;
  bodyUuid: unknown;
  geomUuid: unknown;
}) {
  const body = String(bodyUuid || "").trim();
  const geom = String(geomUuid || "").trim();
  const mesh = meshUuid ? String(meshUuid).trim() || null : null;
  state = {
    active: !!body && !!geom,
    mode,
    meshUuid: mesh,
    bodyUuid: body || null,
    geomUuid: geom || null,
  };
}

export function deactivateVisualGeomOriginPick() {
  state = {
    ...state,
    active: false,
  };
}
